import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";
import moment from 'moment';

class Splinechart extends Component {
    constructor(props) {
        super(props);
        let largest = 0;
        for (let i = 0; i < props?.value.length; i++) {
            if (parseFloat(props?.value[i]) > largest) {
                largest = parseFloat(props?.value[i]);
            }
        }
        this.state = {
            series: [{
                name: props?.name,
                data: props?.value?.map((val) => val)
            }],
            options: {
                chart: {
                    height: 285,
                    type: 'area', // Use 'area' instead of 'line' to support background fill
                    toolbar: {
                        show: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#1DBF73"],
                markers: {
                    size: 3,
                    strokeColor: ["#fff"],
                },
                stroke: {
                    width: 2,
                    curve: 'smooth',
                    colors: ['#E9E9E9']
                },
                fill: {
                    type: "gradient",
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 1, // Adjust transparency at the top
                        opacityTo: 0.5, // More transparent at the bottom
                        colorStops: [
                            { offset: 0, color: "#1DBF73", opacity: 0.5 },
                            { offset: 100, color: "#ffffff", opacity: 0.1 }
                        ]
                    }
                },
                xaxis: {
                    type: 'category',
                    axisTicks: { show: false },
                    axisBorder: { show: false },
                    categories: props?.date?.map((val) => val)
                },
                yaxis: {
                    tickAmount: 8,
                    min: 0,
                    max: parseInt(largest) + 50
                },
                legend: {
                    show: false
                },
            },
        };
    }
    render() {
        return (
            <div>
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="area"
className="chart-class"
                    height="285px"
                />
            </div>
        );
    }
}

export default Splinechart;
